import { PenLine } from 'lucide-react';

interface Signatory {
  name: string;
  role: string;
  nhcId?: string;
  licenseNo?: string;
  institution?: string;
}

interface Props {
  signatories: Signatory[];
}

export default function DigitalSignatureBlock({ signatories }: Props) {
  return (
    <div className="a4-keep-together flex flex-wrap justify-between gap-4 pt-4 mt-4 border-t-2 border-gray-800">
      {signatories.map((s, i) => (
        <div key={i} className="flex flex-col items-center text-center min-w-[120px]">
          <div className="w-24 border-b-2 border-gray-400 mb-1.5 flex items-center justify-center pb-1">
            <PenLine className="w-3 h-3 text-gray-300" />
          </div>
          <p className="text-[10px] font-bold text-gray-900">{s.name}</p>
          <p className="text-[9px] text-gray-600">{s.role}</p>
          {s.institution && <p className="text-[8px] text-gray-500">{s.institution}</p>}
          {s.nhcId && <p className="text-[8px] text-gray-400 font-mono">{s.nhcId}</p>}
          {s.licenseNo && <p className="text-[8px] text-gray-400">Lic: {s.licenseNo}</p>}
        </div>
      ))}
    </div>
  );
}
